import React, { useState, useEffect, useRef, useCallback } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import "../../jobHistory.scss";
import {
  CallIcon,
  DownArrow,
  LocationIcon,
  SearchIcon,
  StarOutline,
} from "../../components/Icons";
import Paginate from "../../components/paginate/Paginate";
import UserImg from "../../assets/images/user.jpg";
import {
  fetchJobs,
  fetchProviderJobInvoice,
  markJobComplete,
  getJobQuoteStatusById,
  updateProviderStartJob,
} from "../../services/auth.service";

import JobContainer from "./JobContainer";
import Search from "../../components/search/Search";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../slice/commonSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toast_error, toast_success, toast_warning } from "../../config/Constant";
import RaiseDispute from "../../modals/raiseDispute/RaiseDispute";
import OTP from "../../modals/userverifiyJobOtp/OTP";
import ReviewModal from "../../modals/review/ReviewModal";
import { selectUser } from "../../slice/authSlice";
import { base64toBlob } from "../../utils/common";
import EndSelfieModal from "../../modals/endSelfie/EndSelfieModal";

const JobHistoryProvider = () => {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isJobRequest, setJobRequest] = useState(false);
  const [jobRequestCount, setJobRequestCount] = useState(null);
  const [jobList, setJobList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [disputeJob, setDisputeJob] = useState({});
  const [selectedJob, setSelectedJob] = useState({});
  const [disputeModal, setDisputeModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [reviewModal, setReviewModal] = useState(false);
  const [endSelfieModal, setEndSelfieModal] = useState(false)
  const [details, setDetails] = useState({})

  const listRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleTabClick = (index) => {
    setActiveTab(index);
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  };

  const user = useSelector(selectUser);
  let roles = user?.userType;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSearchTerm("");
    setCurrentPage(1);
    fetchJoblist(1);
  }, [activeTab]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleJobRequest = () => {
    navigate("/provider/jobrequest");
    // setJobRequest(true);
    // setActiveTab('Incoming')
  };

  const handleMarkComplete = async (id, userId) => {

    let payload = {
      jobId: id,
      userId,
      jobStatus: "CO"
    };
    await dispatch(setLoader(true));
    try {
      const response = await markJobComplete(payload);
      
      await dispatch(setLoader(false));
      fetchJoblist(currentPage, searchTerm);
    } catch (error) {
      toast.success(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  };

  const handleStartJob = async (job) => {

    await dispatch(setLoader(true));

    const response = await getJobQuoteStatusById({ id: job._id }); // Make sure you're passing the correct payload

    if (response) {
      const status = response.jobStatus; // This should now correctly reference the jobStatus
      

      // Check if the quoteStatus is undefined or pending
      if (status === undefined || status === "pending") {
        await dispatch(setLoader(false));
        toast.error("You can begin once they approve your revised quote.", toast_warning);
      } else {
        // Proceed to update providerStartJob
        const res = await updateProviderStartJob({ jobId: job._id });
        if (res) {
          await dispatch(setLoader(false));
          toast.success("Job started successfully!", toast_warning);
          fetchJoblist(currentPage, searchTerm);
        } else {
          await dispatch(setLoader(false));
          toast.error("Failed to start the job.", toast_warning);
        }
      }
    } else {

      toast.error("Error retrieving job quote status.", toast_warning);
    }
  };

  const fetchJoblist = async (page, term = "") => {
    let payload = {
      pageNumber: page,
      jobStatus: jobStatus(), // UPCOMING, CO, CN, PAST
      search: term,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobs(payload);
      await dispatch(setLoader(false));
      setJobRequestCount(response?.data?.jobRequestCount);
      setJobList(response.data?.jobs);
      setTotalPages(response.data?.totalPages);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching profile data:", error);
    }
  };

  const jobStatus = () => {
    if (activeTab === "upcoming") {
      return "UPCOMING";
    } else if (activeTab === "completed") {
      return "CO";
    } else if (activeTab === "cancelled") {
      return "CN";
    } else if (activeTab === "past") {
      return "PAST";
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchJoblist(page, searchTerm);
  };

  const handleOtpModal = (id, job) => {
    setJobId(id);
    setOtpModal(true);
    setSelectedJob(job);
  };

  const handleReviewModal = (job) => {
    setSelectedJob(job);
    setReviewModal(true);
  };

  const handleDispute = (status, job) => {
    setDisputeJob(job);
    setDisputeModal(status);
  };

  const handleDisputeSuccess = () => {
    fetchJoblist(currentPage, searchTerm);
  };

  const handleReviewSuccess = () => {
    fetchJoblist(currentPage, searchTerm);
  };

  const handleSearch = useCallback(
    (term) => {
      setSearchTerm(term);
      setCurrentPage(1);
      fetchJoblist(1, term);
    },
    [setSearchTerm]
  );


  //function to generate jonb invoice pdf
  const handleInvoice = async (job) => {
    try {
      const payload = {
        jobId: job?._id,
        userType: roles,
      };
      await dispatch(setLoader(true));
      const response = await fetchProviderJobInvoice(payload);
      if (response?.data?.status) {
        const pdfData = response.data.data; // Base64 encoded PDF data
        const blob = base64toBlob(pdfData, 'application/pdf');
        const link = document.createElement("a");
        const blobUrl = window.URL.createObjectURL(blob);
        link.href = blobUrl;

        var currentDate = new Date();
        var year = currentDate.getFullYear();
        var month = ("0" + (currentDate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
        var day = ("0" + currentDate.getDate()).slice(-2);

        // Create the file name with the current date
        var fileName = "jobsinvoice_" + year + "_" + month + "_" + day + ".pdf";

        // Set the download attribute of the link
        link.download = fileName;
        // link.download = 'transactions-export.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        await dispatch(setLoader(false));
      } else {
        toast.error(response?.data?.message);
        await dispatch(setLoader(false));
      }
    } catch (error) {
      console.log("error", error);
      await dispatch(setLoader(false));
    }
  };

  const handleEndSelfieClose = () => {
    setEndSelfieModal(false)
    fetchJoblist(currentPage, searchTerm);
  }


  const handlePageRefresh = () => {
    fetchJoblist(currentPage, searchTerm);
  }

  const handleEndSelfieOpen = (job) => {
    setDetails(job)
    setEndSelfieModal(true)
  }


  return (
    <>
      <Header />
      <PageHeading title="Jobs" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="job-history-header">
            <div className="job-search">
              <Search
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}
                onSearch={handleSearch}
              />
              <div className="job-request-wrap">
                <Button
                  variant="outline-primary"
                  onClick={() => handleJobRequest()}
                >
                  Job Request ({jobRequestCount || 0})
                </Button>
              </div>
            </div>
            {isJobRequest ? (
              <>
                <div className="job-nav">
                  <ul>
                    <li
                      className={`${activeTab === "Incoming" ? "active" : ""}`}
                      onClick={() => handleTabClick("Incoming")}
                    >
                      Incoming
                    </li>
                    <li
                      className={`${activeTab === "Outgoing" ? "active" : ""}`}
                      onClick={() => handleTabClick("Outgoing")}
                    >
                      Outgoing
                    </li>
                  </ul>
                </div>
                <div className=" ">
                  <div className="job-nav-header" onClick={toggleDropdown}>
                    <div>{activeTab}</div>{" "}
                    <div>
                      <DownArrow />
                    </div>
                  </div>
                  {dropdownOpen && (
                    <ul ref={listRef}>
                      <li
                        className={`${activeTab === "upcoming" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("upcoming")}
                      >
                        Ongoing
                      </li>
                      <li
                        className={`${activeTab === "completed" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("completed")}
                      >
                        Completed
                      </li>
                      <li
                        className={`${activeTab === "cancelled" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("cancelled")}
                      >
                        Cancelled
                      </li>
                      {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
                    </ul>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="job-nav">
                  <ul>
                    <li
                      className={`${activeTab === "upcoming" ? "active" : ""}`}
                      onClick={() => handleTabClick("upcoming")}
                    >
                      Ongoing
                    </li>
                    <li
                      className={`${activeTab === "completed" ? "active" : ""}`}
                      onClick={() => handleTabClick("completed")}
                    >
                      Completed
                    </li>
                    <li
                      className={`${activeTab === "cancelled" ? "active" : ""}`}
                      onClick={() => handleTabClick("cancelled")}
                    >
                      Cancelled
                    </li>
                    {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
                  </ul>
                </div>
                <div className="job-nav-dropdown">
                  <div className="job-nav-header" onClick={toggleDropdown}>
                    <div>{activeTab}</div>{" "}
                    <div>
                      <DownArrow />
                    </div>
                  </div>
                  {dropdownOpen && (
                    <ul ref={listRef}>
                      <li
                        className={`${activeTab === "upcoming" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("upcoming")}
                      >
                        Ongoing
                      </li>
                      <li
                        className={`${activeTab === "completed" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("completed")}
                      >
                        Completed
                      </li>
                      <li
                        className={`${activeTab === "cancelled" ? "active" : ""
                          }`}
                        onClick={() => handleTabClick("cancelled")}
                      >
                        Cancelled
                      </li>
                      {/* <li className={`${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Past</li> */}
                    </ul>
                  )}
                </div>
              </>
            )}
          </div>

          <div className="job-tab-content-wrap">
            {activeTab === "upcoming" && (
              <JobContainer
                handlePageRefresh={handlePageRefresh}
                handleStartJob={handleStartJob}
                handleMarkComplete={handleOtpModal}
                handleEndSelfieOpen={handleEndSelfieOpen}
                type="upcoming"
                list={jobList}
              />
            )}
            {activeTab === "completed" && (
              <JobContainer
                handleDispute={handleDispute}
                handleReview={handleReviewModal}
                handleInvoice={handleInvoice}
                type="completed"
                list={jobList}
              />
            )}
            {activeTab === "cancelled" && (
              <JobContainer type="cancelled" list={jobList} />
            )}
            {activeTab === "past" && (
              <JobContainer type="past" list={jobList} />
            )}
          </div>
          {jobList?.length > 0 && (
            <Paginate
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
      <Footer />
      {disputeModal ? (
        <RaiseDispute
          disputeJob={disputeJob}
          handleDisputeSuccess={handleDisputeSuccess}
          setDisputeModal={setDisputeModal}
          disputeModal={disputeModal}
        />
      ) : null}
      {reviewModal ? (
        <ReviewModal
          job={selectedJob}
          handleReviewSuccess={handleReviewSuccess}
          setReviewModal={setReviewModal}
          reviewModal={reviewModal}
        />
      ) : null}
      {otpModal ? (
        <OTP
          otpModal={otpModal}
          jobId={jobId}
          handleMarkComplete={handleMarkComplete}
          setOtpModal={setOtpModal}
          handleDispute={handleDispute}
          job={selectedJob}
        />
      ) : null}
      {endSelfieModal ? (
        <EndSelfieModal
          endSelfieModal={endSelfieModal}
          handleEndSelfieClose={handleEndSelfieClose}
          details={details}
        />
      ) : null}
    </>
  );
};

export default JobHistoryProvider;
